<script lang="ts">
import type { Link } from '../../../../types/link';
import Facebook from './icons/facebook.svg';
import Instagram from './icons/instagram.svg';
import LinkedIn from './icons/linkedin.svg';
import X from './icons/x.svg';
import Xing from './icons/xing.svg';
import Youtube from './icons/youtube.svg';
import WeChat from './icons/wechat.svg';
import Weibo from './icons/weibo.svg';
import Youku from './icons/youku.svg';
import TikTok from './icons/tiktok.svg';

type Props = {
  items: Link[];
};

const iconMap = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: LinkedIn,
  x: X,
  xing: Xing,
  youtube: Youtube,
  wechat: WeChat,
  weibo: Weibo,
  youku: Youku,
  tiktok: TikTok,
};
</script>

<script setup lang="ts">
defineProps<Props>();
</script>

<template>
  <div :class="$style.social">
    <a
      v-for="item in items"
      :key="item.id"
      :aria-label="item.label"
      :href="item.url"
      :target="item.target"
    >
      <component :is="iconMap[item.icon]" v-if="item.icon" aria-hidden="true" />
    </a>
  </div>
</template>

<style module lang="scss" src="./Social.scss" />
